import { Combobox } from '@round/creatorbase-ui';
import { useCreatedByCombobox, UserItem } from './useCreatedByCombobox';

export const CREATED_BY_PLACEHOLDER = 'Created by…';

type Props = {
    value: string | undefined;
    onChange: (createdBy: string) => void;
    clientId: number | undefined;
};

export const CreatedByFilter = ({ value, onChange, clientId }: Props) => {
    const { items, selectedItem, open, onOpenChange, onInputValueChange, onItemsListScroll, filter, noItemsFound } =
        useCreatedByCombobox({ selectedId: value, clientId });

    return (
        <Combobox
            multiple={false}
            items={items}
            value={selectedItem}
            // Clearing writes an empty value, which is stripped from the url and from the request alike.
            onValueChange={(selected: UserItem | null) => onChange(selected ? String(selected.value) : '')}
            isItemEqualToValue={(a, b) => a.value === b.value}
            filter={filter}
            open={open}
            onOpenChange={onOpenChange}
            onInputValueChange={onInputValueChange}
            onItemsListScroll={onItemsListScroll}
            noItemsFound={noItemsFound}
            placeholder={CREATED_BY_PLACEHOLDER}
            isClearable
        />
    );
};
